import { Injectable } from '@angular/core';
import { NestApiProvider } from '../../nest-api';
import { ResponseData } from '../../nest-responses';
import {
  RequestListEmployeeMood,
  RequestSubmitSurveyMoodDto,
  ResponseCategorieEmployeeMoodDto,
  ResponseDevelopmentMood,
  ResponseListEmployeeMood,
  ResponseTrendingTopic,
} from '../dto/employee-mood.dto';
import { Observable } from 'rxjs';

@Injectable()
export class EmployeeMoodApi {
  private service: string = '';
  private model: string = 'employee-mood';

  constructor(
    private nestApiProvider: NestApiProvider
  ) {

  }

  public getCategory() {
    const method: string = 'GET';
    const func: string = '';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<Array<ResponseCategorieEmployeeMoodDto>>>(method, url, params, urlParams, body);
  }


  public submitSurvey(payload: RequestSubmitSurveyMoodDto) {
    const method: string = 'POST';
    const func: string = '';
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public score(): Observable<ResponseData<number>> {
    const method: string = 'GET';
    const func: string = 'score';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<number>>(method, url, params, urlParams, body);
  }

  public happyList(payload: RequestListEmployeeMood): Observable<ResponseData<ResponseListEmployeeMood[]>> {
    const method: string = 'GET';
    const func: string = 'happyList';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseListEmployeeMood[]>>(method, url, params, urlParams, body);
  }

  public unhappyList(payload: RequestListEmployeeMood): Observable<ResponseData<ResponseListEmployeeMood[]>> {
    const method: string = 'GET';
    const func: string = 'unhappyList';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseListEmployeeMood[]>>(method, url, params, urlParams, body);
  }

  public trending(): Observable<ResponseData<ResponseTrendingTopic[]>> {
    const method: string = 'GET';
    const func: string = 'trending';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseTrendingTopic[]>>(method, url, params, urlParams, body);
  }

  public developmentMood(): Observable<ResponseData<ResponseDevelopmentMood[]>> {
    const method: string = 'GET';
    const func: string = 'developmentMood';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseDevelopmentMood[]>>(method, url, params, urlParams, body);
  }

  public getMoodCategory(): Observable<any> {
    const method: string = 'GET';
    const func: string = 'moodCategory';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }

  public saveMoodCategory(payload: { name: string, description: string }): Observable<any> {
    const method: string = 'POST';
    const func: string = 'moodCategory';
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }

  public deleteMoodCategory(id: number): Observable<any> {
    const method: string = 'DELETE';
    const func: string = 'moodCategory';
    const params: any = { id };
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }

  public getMoodSurvey(): Observable<any> {
    const method: string = 'GET';
    const func: string = 'moodSurvey';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }

  public saveMoodSurvey(payload: {
    moodSurveyFrequency: string,
    moodSurveyPeriod: string
    surveyGivenAt: string
    startDate: string
    endDate: string
    surveyPrompt: string
  }): Observable<any> {
    const method: string = 'POST';
    const func: string = 'moodSurvey';
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }

  public deleteMoodSurvey(id: number): Observable<any> {
    const method: string = 'DELETE';
    const func: string = 'moodSurvey';
    const params: any = { id };
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/employee-mood.api.ts